
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Loading = ({ progress }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    }}>
      <FontAwesomeIcon icon={faSpinner} spin style={{ color: 'white', fontSize: '48px' }} />
      {progress != null && (
        <div style={{
          marginTop: '24px',
          width: '200px',
          height: '3px',
          backgroundColor: '#333',
          borderRadius: '2px',
          overflow: 'hidden',
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: '#e9fc53',
            transition: 'width 0.3s ease',
          }} />
        </div>
      )}
    </div>
  );
};

export default Loading;
